import type { StatusColor } from '@uiKit/components/StatusBadge.vue'
import { DEPOSIT_REQUEST_STATUS, type DepositRequestStatus } from '../types/depositRequestsTypes'

const STATUS_COLOR: Record<DepositRequestStatus, StatusColor> = {
  [DEPOSIT_REQUEST_STATUS.INITIATED]: 'info',
  [DEPOSIT_REQUEST_STATUS.PENDING_VERIFICATION]: 'warning',
  [DEPOSIT_REQUEST_STATUS.COMPLETED]: 'success',
  [DEPOSIT_REQUEST_STATUS.REJECTED]: 'danger',
  [DEPOSIT_REQUEST_STATUS.EXPIRED]: 'neutral',
  [DEPOSIT_REQUEST_STATUS.CANCELED]: 'neutral',
}

const STATUS_LABEL: Record<DepositRequestStatus, string> = {
  [DEPOSIT_REQUEST_STATUS.INITIATED]: 'Initiated',
  [DEPOSIT_REQUEST_STATUS.PENDING_VERIFICATION]: 'Pending verification',
  [DEPOSIT_REQUEST_STATUS.COMPLETED]: 'Completed',
  [DEPOSIT_REQUEST_STATUS.REJECTED]: 'Rejected',
  [DEPOSIT_REQUEST_STATUS.EXPIRED]: 'Expired',
  [DEPOSIT_REQUEST_STATUS.CANCELED]: 'Canceled',
}

export function getDepositStatusColor(status: DepositRequestStatus): StatusColor {
  return STATUS_COLOR[status] ?? 'neutral'
}

export function getDepositStatusLabel(status: DepositRequestStatus): string {
  return STATUS_LABEL[status] ?? status
}

/**
 * Short middle-truncated UUID for the operator's eye — keeps prefix
 * and suffix, replaces the middle. Used for ids displayed inline in
 * the drawer header / detail.
 */
export function shortenId(id: string, head = 8, tail = 4): string {
  if (!id) return ''
  if (id.length <= head + tail + 1) return id
  return `${id.slice(0, head)}…${id.slice(-tail)}`
}
